/**
 * Suqa Oud - Global Theme JS
 * Handles scroll animations and global UI states.
 */

document.addEventListener('DOMContentLoaded', () => {
    initScrollReveal();
});

function initScrollReveal() {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target); // Only animate once
            }
        });
    }, observerOptions);

    const elements = document.querySelectorAll('.reveal-on-scroll, .product-card, h1, h2, .hero p');
    elements.forEach(el => {
        el.classList.add('reveal-on-scroll');
        observer.observe(el);
    });
}

// Simple Cart & Search Toggle (Global Helper)
window.toggleDrawer = function (id) {
    const el = document.getElementById(id);
    if (el) el.classList.toggle('active');

    const overlay = document.getElementById(id.replace('drawer', 'overlay').replace('modal', 'overlay'));
    // Naming convention: cart-drawer -> cart-overlay | search-modal -> search-overlay (if exists)
    if (overlay) overlay.classList.toggle('active');
}
